import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef,  Inject, OnChanges, OnDestroy, OnInit, PLATFORM_ID, SimpleChanges, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { AcvisService } from '@app/services/acvis.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Observable, Subject, takeUntil } from 'rxjs';
interface Item {
    code: string;
    name: string;
}
@Component({
    selector: 'clever-room-type-list',
    templateUrl: './room-type-list.component.html',
    styleUrls: ['./room-type-list.component.scss'],
    standalone: false
})
export class RoomTypeListComponent implements OnInit, OnDestroy, OnChanges {
    readonly mode = input<string>(undefined);
    readonly partner = input<Partner>(undefined);
    readonly roomTypeListExt = input<any[]>(undefined);
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    slicenbr: number = 5;
    roomTypeList: Item[];
    roomTypeListEx: any[];

    destroyRef = inject(DestroyRef);

    selectedList: string[] = [];
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected acvisService: AcvisService,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
            this.initroomTypeList();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['roomTypeListExt']) {
            this.checktypesEx(changes['roomTypeListExt'].currentValue);
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initroomTypeList(): void {
        this.acvisService.request({}, 'roomTypeList').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(res => {
            this.checktypes(res?.roomTypeList);
        });
    }

    checktypesEx(array) {
        for (let i = 0; i < array?.length; i++) {
            if(this.partner()?.filters?.['hidezimmer' + array[i].code + 'filter']) {
                array.splice(i, 1);
                i--;
            }
        }

        this.roomTypeListEx = this.sortArray(array);
        this.cdr.detectChanges();
    }

    checktypes(array) {
        for (let i = 0; i < array.length; i++) {
            if(this.partner()?.filters?.['hidezimmer' + array[i].code + 'filter']) {
                array.splice(i, 1);
                i--;
            }
        }

        this.roomTypeList = this.sortArray(array);
        this.cdr.detectChanges();
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }

    showMore(all) {
        this.slicenbr = all;
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.selectedList = [];
            if (filter.roomTypeList?.length > 0) {
                for (let i = 0; i < filter.roomTypeList.length; i++) {
                    this.selectedList.push(filter.roomTypeList[i].code);
                }
            }
            this.cdr.detectChanges();
        });
    }

    selected(op): void {
        let push = true;
        if (this.selectedList.indexOf(op.code) >= 0) {
            push = false;
        }
        this.hotelService.roomTypeList(op, push);
        this.cdr.detectChanges();
    }
}
